import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const SalaryReportLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "SalaryReport" */
      './SalaryReport.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
